<template>
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1254_7254)">
      <path
        d="M2 24.25H28C28.5304 24.25 29.0391 24.4607 29.4142 24.8358C29.7893 25.2109 30 25.7196 30 26.25V30.5H0V26.25C7.77001e-09 25.7196 0.210714 25.2109 0.585786 24.8358C0.960859 24.4607 1.46957 24.25 2 24.25Z"
        fill="#111314"
        fill-opacity="0.72"
      />
      <path
        d="M28.75 26.25C28.75 26.1515 28.7306 26.054 28.6929 25.963C28.6552 25.872 28.6 25.7893 28.5303 25.7197C28.4607 25.65 28.378 25.5948 28.287 25.5571C28.196 25.5194 28.0985 25.5 28 25.5H2C1.80109 25.5 1.61032 25.579 1.46967 25.7197C1.32902 25.8603 1.25 26.0511 1.25 26.25V29.25H28.75V26.25Z"
        fill="white"
      />
      <path
        d="M4 26.75H13.5C13.6667 26.75 13.75 26.8333 13.75 27V27.75C13.75 27.9167 13.6667 28 13.5 28H4C3.83333 28 3.75 27.9167 3.75 27.75V27C3.75 26.8333 3.83333 26.75 4 26.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M15.25 26.75H19.75C19.9167 26.75 20 26.8333 20 27V27.75C20 27.9167 19.9167 28 19.75 28H15.25C15.0833 28 15 27.9167 15 27.75V27C15 26.8333 15.0833 26.75 15.25 26.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M21.5 26.75H23.5C23.6667 26.75 23.75 26.8333 23.75 27V27.75C23.75 27.9167 23.6667 28 23.5 28H21.5C21.3333 28 21.25 27.9167 21.25 27.75V27C21.25 26.8333 21.3333 26.75 21.5 26.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M25.25 26.75H26C26.1667 26.75 26.25 26.8333 26.25 27V27.75C26.25 27.9167 26.1667 28 26 28H25.25C25.0833 28 25 27.9167 25 27.75V27C25 26.8333 25.0833 26.75 25.25 26.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M26.75 5.5C27.2804 5.5 27.7891 5.71071 28.1642 6.08579C28.5393 6.46086 28.75 6.96957 28.75 7.5V21C28.75 21.5304 28.5393 22.0391 28.1642 22.4142C27.7891 22.7893 27.2804 23 26.75 23H13.25C12.7196 23 12.2109 22.7893 11.8358 22.4142C11.4607 22.0391 11.25 21.5304 11.25 21V7.5C11.25 6.96957 11.4607 6.46086 11.8358 6.08579C12.2109 5.71071 12.7196 5.5 13.25 5.5H26.75Z"
        fill="#EDEEF0"
      />
      <path
        d="M21.5 15.5H22.25C22.3875 15.5 22.5 15.6125 22.5 15.75V23H21.25V15.75C21.25 15.6125 21.3625 15.5 21.5 15.5ZM25 5.5H23.75V9C23.75 9.1375 23.8625 9.25 24 9.25H24.75C24.7828 9.25 24.8153 9.24353 24.8457 9.23097C24.876 9.21841 24.9036 9.19999 24.9268 9.17678C24.95 9.15356 24.9684 9.126 24.981 9.09567C24.9935 9.06534 25 9.03283 25 9V5.5ZM15 5.5H16.25V11.5C16.25 11.5328 16.2435 11.5653 16.231 11.5957C16.2184 11.626 16.2 11.6536 16.1768 11.6768C16.1536 11.7 16.126 11.7184 16.0957 11.731C16.0653 11.7435 16.0328 11.75 16 11.75H15.25C15.2172 11.75 15.1847 11.7435 15.1543 11.731C15.124 11.7184 15.0964 11.7 15.0732 11.6768C15.05 11.6536 15.0316 11.626 15.019 11.5957C15.0065 11.5653 15 11.5328 15 11.5V5.5Z"
        fill="#CACBCC"
      />
      <path
        d="M19 11.75H19.75C19.9167 11.75 20 11.8333 20 12V21.5C20 21.6667 19.9167 21.75 19.75 21.75H19C18.8333 21.75 18.75 21.6667 18.75 21.5V12C18.75 11.8333 18.8333 11.75 19 11.75Z"
        fill="#CACBCC"
      />
      <path
        d="M15.25 15.5H16C16.1667 15.5 16.25 15.5833 16.25 15.75V20.25C16.25 20.4167 16.1667 20.5 16 20.5H15.25C15.0833 20.5 15 20.4167 15 20.25V15.75C15 15.5833 15.0833 15.5 15.25 15.5Z"
        fill="#CACBCC"
      />
      <path
        d="M14.75 19.25H14C13.9672 19.25 13.9347 19.2565 13.9043 19.269C13.874 19.2816 13.8464 19.3 13.8232 19.3232C13.8 19.3464 13.7816 19.374 13.769 19.4043C13.7565 19.4347 13.75 19.4672 13.75 19.5V23H15V19.5C15 19.4337 14.9737 19.3701 14.9268 19.3232C14.8799 19.2763 14.8163 19.25 14.75 19.25Z"
        fill="#CACBCC"
      />
      <path
        d="M14 19.25H16C16.1667 19.25 16.25 19.3333 16.25 19.5V20.25C16.25 20.4167 16.1667 20.5 16 20.5H14C13.8333 20.5 13.75 20.4167 13.75 20.25V19.5C13.75 19.3333 13.8333 19.25 14 19.25Z"
        fill="#CACBCC"
      />
      <path
        d="M21.5 15.5H24.75C24.9167 15.5 25 15.5833 25 15.75V16.5C25 16.6667 24.9167 16.75 24.75 16.75H21.5C21.3333 16.75 21.25 16.6667 21.25 16.5V15.75C21.25 15.5833 21.3333 15.5 21.5 15.5Z"
        fill="#CACBCC"
      />
      <path
        d="M11.25 10.5H16C16.1375 10.5 16.25 10.6125 16.25 10.75V11.5C16.25 11.5328 16.2435 11.5653 16.231 11.5957C16.2184 11.626 16.2 11.6536 16.1768 11.6768C16.1536 11.7 16.126 11.7184 16.0957 11.731C16.0653 11.7435 16.0328 11.75 16 11.75H11.25V10.5ZM19 11.75H28.75V13H19C18.9672 13 18.9347 12.9935 18.9043 12.981C18.874 12.9684 18.8464 12.95 18.8232 12.9268C18.8 12.9036 18.7816 12.876 18.769 12.8457C18.7565 12.8153 18.75 12.7828 18.75 12.75V12C18.75 11.8625 18.8625 11.75 19 11.75Z"
        fill="#CACBCC"
      />
      <path
        d="M23.75 16.125C23.75 16.6223 23.9475 17.0992 24.2992 17.4508C24.6508 17.8025 25.1277 18 25.625 18C26.1223 18 26.5992 17.8025 26.9508 17.4508C27.3025 17.0992 27.5 16.6223 27.5 16.125C27.5 15.6277 27.3025 15.1508 26.9508 14.7992C26.5992 14.4475 26.1223 14.25 25.625 14.25C25.1277 14.25 24.6508 14.4475 24.2992 14.7992C23.9475 15.1508 23.75 15.6277 23.75 16.125Z"
        fill="#5BADFF"
      />
      <path
        d="M13.75 16.125C13.75 16.6223 13.9475 17.0992 14.2992 17.4508C14.6508 17.8025 15.1277 18 15.625 18C16.1223 18 16.5992 17.8025 16.9508 17.4508C17.3025 17.0992 17.5 16.6223 17.5 16.125C17.5 15.6277 17.3025 15.1508 16.9508 14.7992C16.5992 14.4475 16.1223 14.25 15.625 14.25C15.1277 14.25 14.6508 14.4475 14.2992 14.7992C13.9475 15.1508 13.75 15.6277 13.75 16.125Z"
        fill="#CACBCC"
      />
      <path
        d="M22.5 8.625C22.5 9.12228 22.6975 9.59919 23.0492 9.95083C23.4008 10.3025 23.8777 10.5 24.375 10.5C24.8723 10.5 25.3492 10.3025 25.7008 9.95083C26.0525 9.59919 26.25 9.12228 26.25 8.625C26.25 8.12772 26.0525 7.65081 25.7008 7.29918C25.3492 6.94754 24.8723 6.75 24.375 6.75C23.8777 6.75 23.4008 6.94754 23.0492 7.29918C22.6975 7.65081 22.5 8.12772 22.5 8.625Z"
        fill="#CACBCC"
      />
      <path
        d="M9.42499 3.34047L8.41249 2.60547L1.52499 9.96047L3.54749 11.4305L9.42499 3.34047Z"
        fill="#535456"
      />
      <path
        d="M4.72501 10.4043L2.32126 11.093L4.55376 18.8793L8.97626 18.288L4.72501 10.4043Z"
        fill="#535456"
      />
      <path
        d="M8.03125 18.2163H5.18125L3.125 11.55L4.375 11.125L8.03125 18.2163Z"
        fill="white"
      />
      <path
        d="M7.75 3.625C7.75 3.95652 7.8817 4.27446 8.11612 4.50888C8.35054 4.7433 8.66848 4.875 9 4.875C9.33152 4.875 9.64946 4.7433 9.88388 4.50888C10.1183 4.27446 10.25 3.95652 10.25 3.625C10.25 3.29348 10.1183 2.97554 9.88388 2.74112C9.64946 2.5067 9.33152 2.375 9 2.375C8.66848 2.375 8.35054 2.5067 8.11612 2.74112C7.8817 2.97554 7.75 3.29348 7.75 3.625Z"
        fill="#535456"
      />
      <path
        d="M1.25 9.875C1.25 10.3723 1.44754 10.8492 1.79917 11.2008C2.15081 11.5525 2.62772 11.75 3.125 11.75C3.62228 11.75 4.09919 11.5525 4.45082 11.2008C4.80246 10.8492 5 10.3723 5 9.875C5 9.37772 4.80246 8.90081 4.45082 8.54918C4.09919 8.19754 3.62228 8 3.125 8C2.62772 8 2.15081 8.19754 1.79917 8.54918C1.44754 8.90081 1.25 9.37772 1.25 9.875Z"
        fill="#535456"
      />
      <path
        d="M1.875 9.87519C1.87497 10.0394 1.90729 10.2019 1.9701 10.3536C2.0329 10.5053 2.12497 10.6431 2.24105 10.7592C2.35712 10.8753 2.49493 10.9674 2.6466 11.0302C2.79827 11.093 2.96083 11.1254 3.125 11.1254C3.28917 11.1254 3.45173 11.093 3.6034 11.0302C3.75507 10.9674 3.89288 10.8753 4.00895 10.7592C4.12503 10.6431 4.2171 10.5053 4.2799 10.3536C4.34271 10.2019 4.37503 10.0394 4.375 9.87519C4.37503 9.71102 4.34271 9.54846 4.2799 9.39678C4.2171 9.2451 4.12503 9.10728 4.00895 8.99118C3.89288 8.87509 3.75507 8.783 3.6034 8.72017C3.45173 8.65734 3.28917 8.625 3.125 8.625C2.96083 8.625 2.79827 8.65734 2.6466 8.72017C2.49493 8.783 2.35712 8.87509 2.24105 8.99118C2.12497 9.10728 2.0329 9.2451 1.9701 9.39678C1.90729 9.54846 1.87497 9.71102 1.875 9.87519Z"
        fill="white"
      />
      <path
        d="M13 11.4159C13.1656 11.4071 13.3209 11.3329 13.4318 11.2096C13.5427 11.0863 13.6 10.924 13.5912 10.7584C13.5825 10.5928 13.5083 10.4375 13.3849 10.3266C13.2616 10.2157 13.0993 10.1583 12.9337 10.1671C12.3165 10.1994 11.7036 10.0479 11.1724 9.73187C10.6413 9.41579 10.2158 8.94931 9.94977 8.39141C9.68374 7.83352 9.58913 7.20926 9.6779 6.59759C9.76666 5.98592 10.0348 5.41431 10.4485 4.95505C10.8621 4.49578 11.4026 4.16949 12.0017 4.01744C12.6008 3.86538 13.2315 3.89439 13.8141 4.1008C14.3967 4.3072 14.905 4.68174 15.2747 5.17703C15.6445 5.67233 15.859 6.26614 15.8912 6.88338C15.8999 7.04897 15.9739 7.20436 16.0971 7.31536C16.1581 7.37032 16.2293 7.41273 16.3067 7.44016C16.3841 7.4676 16.4661 7.47952 16.5481 7.47525C16.6301 7.47098 16.7105 7.45061 16.7846 7.41529C16.8587 7.37997 16.9251 7.33039 16.9801 7.2694C17.0351 7.2084 17.0775 7.13718 17.1049 7.05979C17.1323 6.9824 17.1443 6.90037 17.14 6.81838C17.0948 5.95424 16.7944 5.12292 16.2767 4.42953C15.759 3.73614 15.0474 3.21184 14.2317 2.92293C13.416 2.63402 12.533 2.59348 11.6943 2.80642C10.8556 3.01937 10.0989 3.47625 9.51985 4.11928C8.94081 4.7623 8.56546 5.5626 8.44126 6.41896C8.31707 7.27531 8.44961 8.14927 8.82213 8.9303C9.19464 9.71132 9.7904 10.3643 10.5341 10.8068C11.2777 11.2492 12.1359 11.4612 13 11.4159Z"
        fill="#535456"
      />
      <path
        d="M12.7762 8.74219C12.7762 9.23947 12.9738 9.71638 13.3254 10.068C13.6771 10.4196 14.154 10.6172 14.6512 10.6172C15.1485 10.6172 15.6254 10.4196 15.9771 10.068C16.3287 9.71638 16.5262 9.23947 16.5262 8.74219C16.5262 8.24491 16.3287 7.76799 15.9771 7.41636C15.6254 7.06473 15.1485 6.86719 14.6512 6.86719C14.154 6.86719 13.6771 7.06473 13.3254 7.41636C12.9738 7.76799 12.7762 8.24491 12.7762 8.74219Z"
        fill="#FFC13C"
      />
      <path
        d="M3.5 18H9C9.13132 18 9.26136 18.0259 9.38268 18.0761C9.50401 18.1264 9.61425 18.2 9.70711 18.2929C9.79996 18.3858 9.87362 18.496 9.92388 18.6173C9.97413 18.7386 10 18.8687 10 19V24.25H2.5V19C2.5 18.8687 2.52587 18.7386 2.57612 18.6173C2.62638 18.496 2.70003 18.3858 2.79289 18.2929C2.88575 18.2 2.99599 18.1264 3.11732 18.0761C3.23864 18.0259 3.36868 18 3.5 18Z"
        fill="#535456"
      />
      <path
        d="M4.25 21.75H5.75C6.08333 21.75 6.25 21.9167 6.25 22.25V22.5C6.25 22.8333 6.08333 23 5.75 23H4.25C3.91667 23 3.75 22.8333 3.75 22.5V22.25C3.75 21.9167 3.91667 21.75 4.25 21.75Z"
        fill="white"
      />
      <path
        d="M4.25 19.25H5.75C6.08333 19.25 6.25 19.4167 6.25 19.75V20C6.25 20.3333 6.08333 20.5 5.75 20.5H4.25C3.91667 20.5 3.75 20.3333 3.75 20V19.75C3.75 19.4167 3.91667 19.25 4.25 19.25Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1254_7254">
        <rect
          width="30"
          height="30"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuProduct',
} as DefineComponent
</script>
